import { QESCheckbox } from "@app/shared/qes-standards";
import { memo } from "react";
//import { useHistory } from "react-router-dom";
import { useImportConfig, useImportResults } from "../hooks";
import { /*AccessPointProcessingOperation,*/ AccessPointProcessingStep, AccessPointProcessingStepResultType } from "../models";
//import { ImportPageRouter } from "../services/importPageRouter";
//import { ImportSidePanelTab } from "../state";

export const resultIcons = {
  [AccessPointProcessingStepResultType.Info]: "fa-info-circle text-primary",
  [AccessPointProcessingStepResultType.Passed]: "fa-check-circle text-success",
  [AccessPointProcessingStepResultType.Adjusted]: "fa-check-circle text-primary",
  [AccessPointProcessingStepResultType.Warning]: "fa-exclamation text-warning",
  [AccessPointProcessingStepResultType.Critical]: "fa-times text-danger",
  [AccessPointProcessingStepResultType.Running]: "fa-spinner",
};

function nonMemoProviderNetworkImportGridRow({ step }: { step: AccessPointProcessingStep }) {
  const { getResult } = useImportResults();
  const { getStep, toggleStep } = useImportConfig();
  //const history = useHistory();
  //const importRouting = new ImportPageRouter();

  const stepConfig = getStep(step);
  const result = getResult(stepConfig.stepType);

  //const editStepButton = stepConfig.configurable ?
  //  (
  //    <div className="d-flex flex-row justify-content-center align-items-center">
  //      <QESButton type="button" className="btn btn-lg p-0" style={{ height: "fit-content" }} onClick={() => importRouting.openSidePanelRoute(history, step, ImportSidePanelTab.Settings)}>
  //        <i className="fa fa-edit" />
  //      </QESButton>
  //    </div>
  //  ) : "";

  //const buildResultButton = () => {
  //  switch (stepConfig.operation.toString()) {
  //    case AccessPointProcessingOperation.Validate:
  //      return result && result.count !== null ? (<QESButton qesTestId="provider-network-import-grid-row_count" qesType="secondary">{result.count}</QESButton>) : "";
  //    case AccessPointProcessingOperation.Query:
  //      return (<QESButton qesTestId="provider-network-import-grid-row_view" qesType="secondary" onClick={() => importRouting.openSidePanelRoute(history, step, ImportSidePanelTab.Results)}>View</QESButton>);
  //    default:
  //      return null;
  //  }
  //};

  const resultIcon = () => {
    return (
      <td className="icon-row">{
        (result && stepConfig.enabled)
          ? (<span><i className={`fa ${resultIcons[result.resultType]}`} /></span>)
          : (<span><i className="fa fa-minus text-muted" /></span>)
      }
      </td>
    );
  };

  const resultText = () => {
    return (<td>{(result && stepConfig.enabled) ? result.resultType : (stepConfig.enabled ? "Ready" : "Disabled")}</td>);
  };

  return (
    <tr key={step}>
      {resultIcon()}
      {resultText()}
      <td style={{ width: "100%" }}>{stepConfig.name}</td>
      {/*
        TODO: add back when we have configurable steps
        <td className="p-1 d-flex flex-row justify-content-end">{buildResultButton()}</td>
        <td className="text-right">{result && result.percent !== null ? `${result.percent}%` : ""}</td>
        <td>{editStepButton}</td>
      */}
      <td>
        <div className="d-flex flex-row justify-content-center">
          <QESCheckbox
            label=""
            id={`${stepConfig.stepType.toString()}-switch`}
            checked={stepConfig.enabled}
            onChange={() => toggleStep(step)}
            testId={`provider-network-import--${stepConfig.name}`}
          />
        </div>
      </td>
    </tr>
  );
}

export const ProviderNetworkImportGridRow = memo(nonMemoProviderNetworkImportGridRow);
